import React, { useState, useEffect } from 'react';
import './UpdateNotification.css';

interface UpdateNotificationProps {
  isVisible: boolean;
  onUpdate: () => void;
  onDismiss: () => void;
}

const UpdateNotification: React.FC<UpdateNotificationProps> = ({
  isVisible,
  onUpdate,
  onDismiss
}) => {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setIsAnimating(true);
    }
  }, [isVisible]);

  if (!isVisible && !isAnimating) {
    return null;
  }

  const handleUpdate = () => {
    setIsAnimating(false);
    setTimeout(() => {
      onUpdate();
    }, 300);
  };

  const handleDismiss = () => {
    setIsAnimating(false);
    setTimeout(() => {
      onDismiss();
    }, 300);
  };

  return (
    <div className={`update-notification-overlay ${isAnimating ? 'visible' : ''}`}>
      <div className="update-notification">
        <div className="update-icon">
          🔄
        </div>
        <div className="update-content">
          <h3>Nova versão disponível!</h3>
          <p>Uma nova versão da aplicação está disponível. Atualizar agora para ter acesso às últimas funcionalidades e correções.</p>
        </div>
        <div className="update-actions">
          <button 
            className="update-btn primary" 
            onClick={handleUpdate}
          >
            Atualizar Agora
          </button>
          <button 
            className="update-btn secondary" 
            onClick={handleDismiss}
          >
            Mais Tarde
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotification;